import { render, staticRenderFns } from "./ErrChart.vue?vue&type=template&id=04920234&scoped=true"
import script from "./ErrChart.vue?vue&type=script&lang=js"
export * from "./ErrChart.vue?vue&type=script&lang=js"
import style0 from "./ErrChart.vue?vue&type=style&index=0&id=04920234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04920234",
  null
  
)

export default component.exports